export default "__VITE_ASSET__8039a1e1__"